module.exports = __webpack_public_path__ + "img/zhuyueqiang.f5d2a0fd.jpeg";